import React, {RefObject} from "react";
import {IRouteProps} from "../../ts/manager/view/ViewInterface";
import {getManager} from "../../ts/manager/Manager";
import eventBus from "../../ts/event/EventBus";
import Error404Partial from "../partial/status/Error404Partial";
import BasicComponent, {IBasicComponentProps} from "./BasicComponent";

export interface IAppComponentProps extends IBasicComponentProps
{
    routeProps:IRouteProps;
    componentVersion?:number;
    key?: string
}

export default class AppComponent<P> extends BasicComponent<P & IAppComponentProps>
{

    props: Readonly<P & IAppComponentProps>;

    componentRef: RefObject<HTMLInputElement|null> = React.createRef();

    modelsInitialized: boolean = false;
    loading: boolean = false;
    didSubmit: boolean = false;
    errorTexts: string[] = [];
    mountStateEstablished = false;


    constructor(props: P & IAppComponentProps)
    {
        super(props);
        this.props = props;
    }

    isStateWaitingForResponse():boolean
    {
        return this.loading || super.isStateWaitingForResponse();
    }


    onInitialStateEstablished()
    {
        super.onInitialStateEstablished();
        getManager().ui.removeRenderingComponent(this);
    }

    componentElement(): HTMLElement | null
    {
        return (this.componentRef?.current as HTMLElement) ?? null;
    }

    wrapComponent(component: React.JSX.Element): React.JSX.Element
    {
        return <div ref={this.componentRef}>
            {component}
        </div>;
    }

    async initModels(): Promise<void>
    {
        return Promise.resolve();
    }

    bindFunctions(): void
    {
        super.bindFunctions();
        this.handleUIRefresh = this.handleUIRefresh.bind(this);
    }

    isDisabled(): boolean
    {
        return this.loading;
    }

    renderInitializeInvalid(): React.JSX.Element
    {
        return <Error404Partial message={"Could not load content"}/>
    }

    initSubmitState(): void
    {
        this.setLoading(true);
        this.didSubmit = false;
        this.errorTexts.length = 0;

        this.refreshState();
    }


    componentDidMount()
    {
        super.componentDidMount();
        this.addStateChangeListeners();
        this.mountStateEstablished = false
        this.whenNextStateEstablished().then(() => {
            this.onMountStateEstablished();
            this.mountStateEstablished = true;
        });
    }

    onMountStateEstablished()
    {

    }

    onInitialize(): void
    {
        super.onInitialize();
        getManager().ui.addRenderingComponent(this);
        this.addStateChangeListeners();

        this.setLoading(true);
        this.initModels().then(() => {
            this.modelsInitialized = true;
            this.onModelsInitialized();
            this.setLoading(false);
            this.refreshState();
        }).catch(() => {
            this.setLoading(false);
            this.refreshState();
        })
    }

    componentDidFirstMount()
    {
        super.componentDidMount();
    }

    onModelsInitialized()
    {

    }

    componentWillUnmount()
    {
        this.removeStateChangeListeners();
        getManager().ui.removeRenderingComponent(this);
        super.componentWillUnmount();
    }

    addStateChangeListeners()
    {
        this.removeStateChangeListeners();
        eventBus.on("site.refresh-ui", this.handleUIRefresh);
    }

    removeStateChangeListeners()
    {
        eventBus.remove("site.refresh-ui", this.handleUIRefresh);
    }

    handleUIRefresh(){
        this.onUIRefresh();
        this.refreshState();
    }

    onUIRefresh(){

    }

    setLoading(value:boolean)
    {
        if(value !== this.loading){
            this.loading = value;
            this.onDisabledStateChange();
        }
    }

    onDisabledStateChange()
    {

    }
}